// For full API documentation, including code examples, visit http://wix.to/94BuAAs

$w.onReady(function () {
	//TODO: write your page related code here...

});

export function image1_viewportLeave(event, $w) {
	//Add your code for this event here: 
}

export function columnStrip1_viewportLeave(event, $w) {
	//Add your code for this event here: 
}
setTimeout(function () {
$w("#image1").hide();
}, 15000);